import { render, staticRenderFns } from "./StepTipoCampanha.vue?vue&type=template&id=1ef282e1&scoped=true"
import script from "./StepTipoCampanha.vue?vue&type=script&lang=js"
export * from "./StepTipoCampanha.vue?vue&type=script&lang=js"
import style0 from "./StepTipoCampanha.vue?vue&type=style&index=0&id=1ef282e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef282e1",
  null
  
)

export default component.exports